module.exports = __webpack_public_path__ + "img/36e188651d3f20e64e69a0abc3d1fb38.png";